import config from 'config/config'
import { I18n } from 'lib/i18n'
import { del, get, patch, post, put } from 'lib/utilities'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'
import { loadDealerState } from 'redux/importer'

export const LOAD_USERS = 'userAdmin/LOAD_USERS'
export const LOAD_USERS_DONE = 'userAdmin/LOAD_USERS_DONE'
export const LOAD_USERS_FAILED = 'userAdmin/LOAD_USERS_FAILED'
export const LOAD_SHOP_USERS = 'userAdmin/LOAD_SHOP_USERS'
export const LOAD_SHOP_USERS_DONE = 'userAdmin/LOAD_SHOP_USERS_DONE'

export const SAVE_USER = 'userAdmin/SAVE'
export const SAVE_USER_DONE = 'userAdmin/SAVE_DONE'
export const SAVE_USER_FAILED = 'userAdmin/SAVE_FAILED'

export const DELETE_USER = 'userAdmin/DELETE'
export const DELETE_USER_DONE = 'userAdmin/DELETE_DONE'
export const DELETE_USER_FAILED = 'userAdmin/DELETE_FAILED'

export const LOAD_IMPORT_USERS = 'userAdmin/LOAD_IMPORT_USERS'
export const LOAD_IMPORT_USERS_DONE = 'userAdmin/LOAD_IMPORT_USERS_DONE'
export const LOAD_IMPORT_USERS_FAILED = 'userAdmin/LOAD_IMPORT_USERS_FAILED'

export const LOAD_IMPORT_USER = 'userAdmin/LOAD_IMPORT_USER'
export const LOAD_IMPORT_USER_DONE = 'userAdmin/LOAD_IMPORT_USER_DONE'
export const LOAD_IMPORT_USER_FAILED = 'userAdmin/LOAD_IMPORT_USER_FAILED'

export const IMPORT_ALL = 'userAdmin/IMPORT_ALL'
export const IMPORT_ALL_DONE = 'userAdmin/IMPORT_ALL_DONE'
export const IMPORT_ALL_FAILED = 'userAdmin/IMPORT_ALL_FAILED'

export const UPDATE_ALL = 'userAdmin/UPDATE_ALL'
export const UPDATE_ALL_DONE = 'userAdmin/UPDATE_ALL_DONE'
export const UPDATE_ALL_FAILED = 'userAdmin/UPDATE_ALL_FAILED'

export const ARCHIVE_ALL = 'userAdmin/ARCHIVE_ALL'
export const ARCHIVE_ALL_DONE = 'userAdmin/ARCHIVE_ALL_DONE'
export const ARCHIVE_ALL_FAILED = 'userAdmin/ARCHIVE_ALL_FAILED'

export const ADMIN_CHANGE_PASSWORD = 'user/ADMIN_CHANGE_PASSWORD'
export const ADMIN_CHANGE_PASSWORD_DONE = 'user/ADMIN_CHANGE_PASSWORD_DONE'
export const ADMIN_CHANGE_PASSWORD_FAILED = 'user/ADMIN_CHANGE_PASSWORD_FAILED'

export const loadUsers = () => ({ type: LOAD_USERS })
export const loadUsersDone = (users) => ({ type: LOAD_USERS_DONE, users })
export const loadUsersFailed = (errors) => ({ type: LOAD_USERS_FAILED, errors })

export const loadShopUsers = () => ({ type: LOAD_SHOP_USERS })
export const loadShopUsersDone = () => ({ type: LOAD_SHOP_USERS_DONE })

export const saveUser = (user) => ({ type: SAVE_USER, user })
export const saveUserDone = (user) => ({ type: SAVE_USER_DONE, user })
export const saveUserFailed = (errors) => ({ type: SAVE_USER_FAILED, errors })

export const deleteUser = (id) => ({ type: DELETE_USER, id })
export const deleteUserDone = () => ({ type: DELETE_USER_DONE })
export const deleteUserFailed = (errors) => ({
  type: DELETE_USER_FAILED,
  errors,
})

export const loadImportUser = (id) => ({ type: LOAD_IMPORT_USER, id })
export const loadImportUserFulfilled = (importUser) => ({
  type: LOAD_IMPORT_USER_DONE,
  importUser,
})
export const loadImportUserFailed = (errors) => ({
  type: LOAD_IMPORT_USER_FAILED,
  errors,
})

export const loadImportUsers = (id) => ({ type: LOAD_IMPORT_USERS, id })
export const loadImportUsersDone = (importUsers) => ({
  type: LOAD_IMPORT_USERS_DONE,
  importUsers,
})
export const loadImportUsersFailed = (errors) => ({
  type: LOAD_IMPORT_USERS_FAILED,
  errors,
})

export const importAllNewDealers = (id) => ({ type: IMPORT_ALL, id })
export const importAllNewDealersFulfilled = () => ({ type: IMPORT_ALL_DONE })
export const importAllNewDealersFailed = (errors) => ({
  type: IMPORT_ALL_FAILED,
  errors,
})

export const updateAllDealers = (id) => ({ type: UPDATE_ALL, id })
export const updateAllDealersFulfilled = () => ({ type: UPDATE_ALL_DONE })
export const updateAllDealersFailed = (errors) => ({
  type: UPDATE_ALL_FAILED,
  errors,
})

export const archiveAllDealers = (id) => ({ type: ARCHIVE_ALL, id })
export const archiveAllDealersFulfilled = () => ({ type: ARCHIVE_ALL_DONE })
export const archiveAllDealersFailed = (errors) => ({
  type: ARCHIVE_ALL_FAILED,
  errors,
})

export const adminChangePassword = (formValues) => ({
  ...formValues,
  type: ADMIN_CHANGE_PASSWORD,
})
export const adminChangePasswordDone = () => ({
  type: ADMIN_CHANGE_PASSWORD_DONE,
})
export const adminChangePasswordFailed = (errors) => ({
  type: ADMIN_CHANGE_PASSWORD_FAILED,
  errors,
})

const initialState = {
  users: [],
  userSaving: false,
}

export const userAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USERS:
      return { ...state, usersLoading: true }
    case LOAD_USERS_DONE:
      return { ...state, usersLoading: false, users: action.users }
    case SAVE_USER:
      return { ...state, userSaving: true, errors: undefined }
    case SAVE_USER_DONE:
      const { user: actionUser = {} } = action
      const index = state.users.findIndex((user) => user.id === actionUser.id)
      if (index >= 0) {
        return {
          ...state,
          users: [
            ...state.users.slice(0, index),
            actionUser,
            ...state.users.slice(index + 1),
          ],
          userSaving: false,
          errors: undefined,
        }
      } else {
        return {
          ...state,
          users: [...state.users, actionUser],
          userSaving: false,
          errors: undefined,
        }
      }
    case SAVE_USER_FAILED:
      return { ...state, userSaving: false, errors: action.errors }

    case LOAD_IMPORT_USERS:
      return { ...state, importUsersLoading: true }
    case LOAD_IMPORT_USERS_DONE:
      return {
        ...state,
        importUsersLoading: false,
        importUsers: action.importUsers,
      }

    case LOAD_IMPORT_USER:
      return { ...state, importUserLoading: true }

    case LOAD_IMPORT_USER_DONE:
      return {
        ...state,
        importUserLoading: false,
        importUser: action.importUser,
      }

    case LOAD_IMPORT_USER_FAILED:
      return { ...state, importUserLoading: false }

    case ADMIN_CHANGE_PASSWORD:
      return { ...state, changingPassword: true }
    case ADMIN_CHANGE_PASSWORD_DONE:
      return { ...state, changingPassword: false }

    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD_USERS)
    .mergeMap((action) => get('/users.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadUsersDone(result.body)]
      } else {
        toast.error(I18n.t('action.user/LOAD_USERS_FAILED'))
        return [loadUsersFailed(result.body.errors)]
      }
    })

export const loadShopUsersEpic = (action$, store) =>
  action$
    .ofType(LOAD_SHOP_USERS)
    .mergeMap(() => get('/users/shop_index.json'))
    .mergeMap(() => [loadShopUsersDone()])

export const saveEpic = (action$, store) =>
  action$
    .ofType(SAVE_USER)
    .filter((action) => action.user.id !== undefined)
    .mergeMap((action) => {
      const {
        mediaIdList: asset_ids,
        addresses: addresses_attributes,
      } = action.user
      delete action.user.mediaIdList
      delete action.user.addresses
      return patch('/users/' + action.user.id, {
        user: { ...action.user, asset_ids, addresses_attributes },
      })
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.user/SAVE_DONE'))
        return [saveUserDone(result.body), loadShopUsers()]
      } else {
        toast.error(I18n.t('action.user/SAVE_FAILED'))
        return [saveUserFailed(result.body.errors)]
      }
    })

export const createEpic = (action$, store) =>
  action$
    .ofType(SAVE_USER)
    .filter((action) => action.user.id === undefined)
    .mergeMap((action) => {
      const {
        mediaIdList: asset_ids,
        addresses: addresses_attributes,
      } = action.user
      return post('/users.json', {
        user: { ...action.user, asset_ids, addresses_attributes },
      })
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.user/CREATE_DONE'))
        return [saveUserDone(result.body), loadShopUsers()]
      } else {
        toast.error(I18n.t('action.user/CREATE_FAILED'))
        return [saveUserFailed(result.body.errors)]
      }
    })

export const deleteEpic = (action$, store) =>
  action$
    .ofType(DELETE_USER)
    .mergeMap((action) => del(`/users/${action.id}.json`))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadUsers(), deleteUserDone(), push(config.nodes.user)]
      } else {
        toast.error(I18n.t('action.categories/DELETE_USER_FAILED'))
        return [deleteUserFailed(result.body.errors)]
      }
    })

export const loadImportUsersEpic = (action$, store) =>
  action$
    .ofType(LOAD_IMPORT_USERS)
    .mergeMap((action) => get('/import_dealers.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadImportUsersDone(result.body)]
      } else {
        toast.error(I18n.t('action.user/LOAD_IMPORT_USERS_FAILED'))
        return [loadImportUsersFailed(result.body.errors)]
      }
    })

export const loadImportUserEpic = (action$, store) =>
  action$
    .ofType(LOAD_IMPORT_USER)
    .mergeMap((action) => get('/import_dealers/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadImportUserFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.dealers/LOAD_IMPORT_FAILED'))
        return [loadImportUserFailed(result.body.errors)]
      }
    })

export const adminSubmitNewPasswordEpic = (action$, store) =>
  action$
    .ofType(ADMIN_CHANGE_PASSWORD)
    .mergeMap((action) => {
      return put('/users/password.json', {
        user: {
          password: action.password,
          password_confirmation: action.password_confirmation,
          id: action.id,
        },
      })
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.user/CHANGE_PASSWORD_DONE'))
        return [adminChangePasswordDone()]
      } else {
        toast.error(I18n.t('action.user/CHANGE_PASSWORD_FAILED'))
        return [adminChangePasswordFailed(result.body.errors)]
      }
    })

export const importAllEpic = (action$, store) =>
  action$
    .ofType(IMPORT_ALL)
    .mergeMap((action) => {
      return put('/import_dealers/accept_all_imports.json')
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.dealers/IMPORT_ALL_DONE'))
        return [importAllNewDealersFulfilled(), loadDealerState()]
      } else {
        toast.error(I18n.t('action.dealers/IMPORT_ALL_FAILED'))
        return [importAllNewDealersFailed(result.body.errors)]
      }
    })

export const updateAllEpic = (action$, store) =>
  action$
    .ofType(UPDATE_ALL)
    .mergeMap((action) => {
      return put('/import_dealers/accept_all_updates.json')
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.dealers/UPDATE_ALL_DONE'))
        return [updateAllDealersFulfilled(), loadDealerState()]
      } else {
        toast.error(I18n.t('action.dealers/UPDATE_ALL_FAILED'))
        return [updateAllDealersFailed(result.body.errors)]
      }
    })

export const archiveAllEpic = (action$, store) =>
  action$
    .ofType(ARCHIVE_ALL)
    .mergeMap((action) => {
      return put('/users/accept_all_archives.json')
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.dealers/ARCHIVE_ALL_DOME'))
        return [archiveAllDealersFulfilled(), loadDealerState()]
      } else {
        toast.error(I18n.t('action.dealers/ARCHIVE_ALL_FAILED'))
        return [archiveAllDealersFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/userAdmin.js